const budget = {
  getlist: 'budget/getlist',
  add: 'budget/add',
  update: 'budget/update',
  remove: 'budget/remove',
  get: 'budget/get',
  getall: 'budget/getall',
}
export default budget
